import { StyleSheet, Text, TextInput, View } from "react-native";
import React, { useLayoutEffect, useState } from "react";

import Button from "../components/Button";

const Login = ({ navigation }) => {
  const [userName, setUserName] = useState("");

  useLayoutEffect(() => {
    let storageUserName = localStorage.getItem("fubon2022UserName");
    if (storageUserName) {
      navigation.navigate("Home", {
        screen: "HomePage",
        params: { userName: storageUserName },
      });
    }
  }, []);

  const submitNameHandler = async () => {
    //fetch database to create a new user or searching exiting user.
    console.log(userName);
    if (userName.length === 0) {
      alert("輸入錯誤，請記得要輸入正確姓名喔！");
      return;
    }
    localStorage.setItem("fubon2022UserName", userName);

    navigation.navigate("Home", {
      screen: "HomePage",
      params: { userName: userName },
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.title}>Hi!親愛的講師!</Text>
        <Text style={styles.text}>請您輸入您的大名：</Text>
        <TextInput
          style={styles.input}
          onChangeText={setUserName}
          value={userName}
        />
        <Button
          onPress={submitNameHandler}
          title="確認"
          style={{
            marginHorizontal: "auto",
            padding: 5,
            width: 100,
            marginBottom: 20,
          }}
        />
        <Text style={styles.text}>
          請輸入真實姓名（全名），後續對獎才有效喔！
        </Text>
        <Text style={styles.warning}>
          ＊若您之前已輸入過，請重新輸入相同的姓名，抽獎紀錄才會保留。
        </Text>
      </View>
    </View>
  );
};

export default Login;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",

    backgroundColor: "#EFD7AC",
  },
  textContainer: {
    margin: 60,
    width: 300,
  },
  title: {
    fontSize: 30,
    fontWeight: "bold",
    color: "#FAA200",
    borderBottomColor: "#F8B02A",
  },
  text: {
    fontSize: 20,
    color: "#7B5401",
  },
  input: {
    borderBottomColor: "#EF2929",
    borderBottomWidth: 2,
    height: 40,
    padding: 10,
    margin: 20,
    color: "#5D4303",
    fontSize: 30,
  },
  warning: {
    color: "#EF2929",
  },
});
